import AbstractFormulaNode from "./AbstractFormulaNode.js";
import specificationFactory from "../../specification/specificationFactory.js";

/**
 * `accountFormulaNode` is a node whose value can be an opening balance, a closing balance,
 * or a period change depending on the evaluation context.
 *
 * @param {accountSpecification} spec.accountSpecification - Specification of accounts
 */
export default class AccountFormulaNode extends AbstractFormulaNode {
	constructor({ accountSpecification }) {
		super(...arguments);
		this._accountSpecification = accountSpecification;
	}

	getAccountSpecification() {
		return this._accountSpecification;
	}

	accept(visitor, additionalInformation) {
		return visitor.visitAccountNode(this, additionalInformation);
	}

	_serializedProperties() {
		const properties = super._serializedProperties(...arguments);

		properties.accountSpecification = this._accountSpecification;

		return properties;
	}

	static getType() {
		return "AccountNode";
	}

	static transformMaterializationData(data, context) {
		super.transformMaterializationData(...arguments);

		data.accountSpecification = specificationFactory.materialize(
			data.accountSpecification,
			context,
		);
	}
}
